import { track } from "@amplitude/analytics-react-native";
import { useCallback, useMemo } from "react";
import { View } from "react-native";
import { ShareWrapper } from "src/components/ShareMenu";
import { ShareWrapperProps } from "src/components/ShareMenu/ShareWrapper";
import { SharePayload } from "src/components/ShareMenu/types";
import { paddingMedium, paddingXXL } from "src/styles/spacing";
import RecapAssetShareDownload from "./components/RecapAssetShareDownload";
import RecapAssetShareInstagram from "./components/RecapAssetShareInstagram";

const RecapAssetShareContent = ({
	url,
	variant,
	accompanyingAssetShareUrl,
	trackingIdentifier,
}: {
	url: string;
	variant: "Image" | "Video";
	accompanyingAssetShareUrl: string | null | undefined;
	trackingIdentifier: string | undefined;
}) => {
	const data = useMemo<SharePayload[]>(() => {
		switch (variant) {
			case "Image":
				return [
					{
						type: "Image",
						url,
						accompanyingAssetShareUrl: accompanyingAssetShareUrl ?? undefined,
					},
				];
			case "Video":
				return [
					{
						type: "Video",
						videoUrl: url,
						accompanyingAssetShareUrl: accompanyingAssetShareUrl ?? undefined,
					},
				];
		}
	}, [url, variant, accompanyingAssetShareUrl]);
	const renderItems = useCallback<NonNullable<ShareWrapperProps["renderItems"]>>((options) => {
		// IG should come first
		const reversedOptions = [...options].reverse();
		return (
			<>
				{reversedOptions.map((option) => {
					if (option.key === "ShareDownload") {
						return (
							<RecapAssetShareDownload
								key={option.key}
								data={option.data}
								hasInstagramShare={reversedOptions.some(
									(option) => option.key === "ShareInstagramStory",
								)}
							/>
						);
					}
					if (option.key === "ShareInstagramStory") {
						return <RecapAssetShareInstagram key={option.key} data={option.data} />;
					}
					return null;
				})}
			</>
		);
	}, []);
	return (
		<View
			style={{
				width: "100%",
				alignItems: "center",
				rowGap: paddingMedium,
				overflow: "hidden",
				marginTop: paddingXXL,
			}}
		>
			<ShareWrapper
				data={data}
				renderItems={renderItems}
				onComplete={() => {
					track("recap_share_complete", {
						trackingIdentifier,
					});
				}}
				onSuccess={() => {
					track("recap_share_success", {
						trackingIdentifier,
					});
				}}
			/>
		</View>
	);
};
export default RecapAssetShareContent;
